import React, { useRef } from "react";
import * as PropTypes from "prop-types";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import CumulativeGapBySectorChart from "./CumulativeGapBySectorChart";

const CumulativeGapBySectorChartWidget = props => {
  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="cumulative_gap_by_sector_chart"
      reference="Figure 1.3"
      title="Cumulative Gap by Sector, 2021–2025"
      subtitle="Comparison by GNI Group"
      contentWidth={350}
      initialAbsolute={false}
      chartRef={ref}
    >
      <CumulativeGapBySectorChart ref={ref} data={props.data} />
    </AbsoluteChartToggleFrame>
  );
};

CumulativeGapBySectorChartWidget.propTypes = {
  data: PropTypes.array.isRequired
};

export default CumulativeGapBySectorChartWidget;
